const types = Object.freeze({
  USER_TOKEN: "[User] User Token",

  idConvocatoria: "[Cvt] id convocatoria",
  edicion: "[Cvt] edicion",
  eliminar: "[Cvt] eliminar",
  cambiarPestaña: "[Cvt] pestaña otras convocatorias",

  idParticipante: "[Prt] id participante",
  id_convocatoria_seleccionada: "[Prt] id convocatoria seleccionada",
  documentos_convocatoria: "[Prt] documentos convocatoria",
  documentos_tecnico_cargados: "[Prt] documentos tecnicos cargados",
  documentos_administrativos_cargados:
    "[Prt] documentos admistrativos cargados",
  categoria_linea_convocatoria: "[Prt] categorias participante",
  fechas_participantes: "[Prt] fechas participante",
  nombre_convocatoria: "[Prt] nombre convocatoria",
  tipo_participante: "[Prt] tipo participante",
  id_postulacion: "[Prt] id postulacion participante",
  datos_postulacion: "[Prt] datosPostulacion",

  id_jurado: "[Jur] id jurado",
  editar_jurado: "[Jur] editar jurado",
  jurado_postulado: "[Jur] jurado postulado",
  invitacion_jurado: "[Jur] invitacion jurado",
  jurados_criterios: "[Jur] criterios jurado",
  jurados_atras: "[Jur] jurado atras",
  jurado_educacion: "[Jur] educacion jurado",
  menu_jurado: "[Jur] menu jurado",
  sec: "[Jur] sec",
  proyectosAsignados: "[Jur] proyectos asignados",

  setModalJuryPostulate: "[Jur] modal categorias evaluacion jurado",

});

export default types;
